import { render, staticRenderFns } from "./ModalNotificacaoAR.vue?vue&type=template&id=4b72493a&lang=pug"
import script from "./ModalNotificacaoAR.vue?vue&type=script&lang=js"
export * from "./ModalNotificacaoAR.vue?vue&type=script&lang=js"
import style0 from "./ModalNotificacaoAR.vue?vue&type=style&index=0&id=4b72493a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports